export default __webpack_public_path__ + "static/media/p52 Home Buying Process.48eb9bfa.pdf";